import AwemeAction from './awemeAction.vue'
export default AwemeAction
